import React, { useState } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import Select from 'components/inputs/Select';
import ButtonList from 'components/inputs/ButtonList';
import SkyPulseTable from 'components/SkyPulseTable';
import DatePicker from 'components/inputs/DatePicker';

import styles from './styles.module.css';

const idPrefix = 'UsageStaticAds';

const columnDefinitions = [
  {
    name: 'Col1',
    key: 'col1',
    size: 'small',
    dataCyClassName: 'Usage-StaticAdsTableColumn-col1',
  },
  {
    name: 'Col2',
    key: 'col2',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-StaticAdsTableColumn-col2',
  },
  {
    name: 'Col3',
    key: 'col3',
    size: 'small',
    dataCyClassName: 'Usage-StaticAdsTableColumn-col3',
  },
];

const data = [
  {
    col1: '1',
    col2: '0123_GAME_TRIVIATOURNAMENT',
    col3: 18810,
  },
];

const StaticAds = () => {
  const [selectedEventFilter, setSelectedEventFilter] = useState('last30Days');
  const [selectedMonth, setSelectedMonth] = useState('january2026');

  const months = [
    { name: 'January 2026', id: 'january2026' },
    { name: 'February 2026', id: 'february2026' },
    { name: 'March 2026', id: 'march2026' },
    { name: 'April 2026', id: 'april2026' },
    { name: 'May 2026', id: 'may2026' },
  ];

  const filterOptions = [
    { name: 'Last 30 days', value: 'last30Days' },
    {
      name: (
        <div>
          <Select
            idPrefix={`${idPrefix}-month`}
            data-cy-id={`${idPrefix}-FiltersPanel-month`}
            label="Month: "
            options={months}
            value={selectedMonth}
            onChange={({ target: { value } }) => setSelectedMonth(value)}
          />
        </div>
      ),
      value: 'month',
    },
    {
      name: (
        <div className={styles.datecontainer}>
          <div>
            <DatePicker
              idPrefix={`${idPrefix}-FilterPanel-from`}
              value={Date.now()}
              label="From:"
              onChange={() => {}}
            />
          </div>
          <div>
            <DatePicker
              idPrefix={`${idPrefix}-FilterPanel-to`}
              value={Date.now()}
              label="To:"
              onChange={() => {}}
            />
          </div>
        </div>
      ),
      value: 'dateRange',
    },
  ];

  return (
    <Row className={styles.root} noGutters>
      <Col>
        <Row className={styles.title} noGutters>
          <Col data-cy-id="Usage-StaticAds-Header" className="title_1">
            Static Ads
          </Col>
        </Row>
        <Row className={styles.filterContainer} noGutters>
          <Col>
            <ButtonList
              key={selectedEventFilter}
              idPrefix="Events-filter"
              name="eventFilters"
              type="radio"
              onChange={(e) => {
                const { value } = e.target;
                setSelectedEventFilter(value);
              }}
              options={filterOptions}
              value={selectedEventFilter}
              arrangementClassName={styles.filterList}
              classname={styles.options}
            />
          </Col>
          <Col md="auto">
            <Button
              className="button_foc"
              data-cy-id="Usage-StaticAds-FilterButton"
              onClick={() => {}}
            >
              Filter
            </Button>
          </Col>
        </Row>
        <Row className={styles.dataContainer} noGutters>
          <Col className="h-100">
            <Row className={styles.tableContainer} noGutters>
              <Col className="h-100">
                <SkyPulseTable
                  columns={columnDefinitions}
                  rows={data}
                  title="Last 30 days"
                  onRowClick={() => {}}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default StaticAds;
